import type { ChromeCopy } from './types'

export const mr: ChromeCopy = {
  appName: 'समझो',
  tagline: 'कागद समजून घ्या. पुढे काय करायचं ते जाणून घ्या.',
  savedTitle: 'सेव्ह केलेले कागद',
  upcomingTitle: 'जवळ येणाऱ्या शेवटच्या तारखा',
  markDone: 'काम झाले',
  doneLabel: 'झाले',
  deadlineCheckIn: '{n} सेव्ह केलेल्या कागदांची शेवटची तारीख जवळ आहे. काम झाले का?',
  savedHint: 'हे फक्त याच फोनवर आहेत. कागदाचा फोटो आणि त्यावर लिहिलेलं सगळं कधीच सेव्ह होत नाही, फक्त महत्त्वाची माहिती.',
  emptySaved: 'अजून कोणताही कागद सेव्ह केलेला नाही.',
  clearAll: 'सगळे हटवा',
  deleteItem: 'हटवा',
  aboutTitle: 'गोपनीयता आणि महत्त्वाची माहिती',
  privacyPoints: [
    'तुमच्या कागदाचा फोटो आणि त्यावर लिहिलेलं याच फोनवर वाचलं आणि समजावलं जातं. फोटो कुठेही अपलोड होत नाही.',
    'तुम्ही "सेव्ह करा" दाबल्याशिवाय काहीही सेव्ह होत नाही. "नवा कागद" दाबताच आधीचा कागद स्क्रीनवरून आणि मेमरीतून काढून टाकला जातो.',
    'सेव्ह केल्यावर फक्त महत्त्वाची माहिती (तारखा, रक्कम, नंबर) ठेवली जाते, तीही फक्त याच फोनवर — फोटो किंवा पूर्ण लिहिलेलं नाही. तुम्ही ही माहिती कधीही हटवू शकता.',
    'इंटरनेट फक्त तीन कामांसाठी वापरलं जातं: पहिल्यांदा वाचण्याचं टूल आणि आवाज (समझोच्या स्वतःच्या साइटवरून) डाउनलोड करण्यासाठी, आणि — फक्त तुम्ही सांगितलं तरच — कागदातल्या इंग्रजी ओळींचं भाषांतर करण्यासाठी. भाषांतरासाठी पाठवलेल्या ओळी साठवल्या जात नाहीत, आणि आधार आणि फोनसारखे नंबर आधीच काढून टाकले जातात. तिसरे — फक्त तुम्ही प्रश्न विचारलात तरच: उत्तर लिहिण्यासाठी कागदातील मजकूर आणि तुमचा प्रश्न समझोच्या सर्व्हरवर आणि एका AI सेवेवर (Groq) जातो, आधार, पॅन, फोन आणि ईमेल आधी काढून; फक्त सरकारी वेबसाइट पाहिल्या जातात, आणि काहीही साठवलं जात नाही. ज्या ओळी इंग्रजीत नाहीत, त्यांचे भाषांतर एक AI सेवा (Groq) करते.',
    'समझोमध्ये कोणतीही जाहिरात नाही. किती लोक ॲप उघडतात, एवढंच आम्ही मोजतो (Cloudflare Web Analytics, कुकीशिवाय). त्यात तुमच्या कागदातलं काहीही नसतं, आणि कागदात काय लिहिलं आहे ते कधीही लॉग (नोंदवलं) केलं जात नाही.'
  ],
  disclaimerTitle: 'हा सरकारी किंवा कायदेशीर सल्ला नाही',
  disclaimer: 'समझो हे एक स्वतंत्र मदतीचं टूल आहे, सरकारी वेबसाइट नाही. ते तुमचा कागद सोप्या भाषेत सांगतं, पण त्याचं समजावणं अधिकृत किंवा कायदेशीर अर्थ नाही. महत्त्वाच्या गोष्टी नेहमी मूळ कागदाशी किंवा तो कागद देणाऱ्या कार्यालयाशी जुळवून पाहा.',
  contactTitle: 'काही अडचण आहे का?',
  contact: 'काही अडचण आली, तर आमच्याशी या ईमेलवर संपर्क करा:',
  freeTitle: 'पूर्णपणे मोफत',
  free: 'समझो ओपन-सोर्स टूल्सवर चालतं: वाचण्यासाठी Tesseract, आणि बोलण्यासाठी तुमच्या फोनचाच आवाज किंवा Meta चे ओपन MMS आवाज (CC BY-NC 4.0). खातं नको, पैसे नको.',
  shareApp: 'WhatsApp वर शेअर करा',
  installApp: 'ॲप फोनमध्ये जोडा',
  offline: 'तुम्ही ऑफलाइन आहात',
  offlineHint: 'आधी समझो वापरलं असेल, तर इंटरनेटशिवायही कागद वाचता येतो.',
  shareAppMessage: 'सरकारी कागद सोप्या भाषेत समजून घेण्यासाठी आणि ऐकण्यासाठी SAMJHO वापरा (मोफत):\nhttps://samjho.pages.dev'
}
